import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyB0nSVHqsJrbRSXc5N0zA1bP659bYqROpc",
    authDomain: "segim-intranet.firebaseapp.com",
    projectId: "segim-intranet",
    storageBucket: "segim-intranet.appspot.com",
    messagingSenderId: "487503667844",
    appId: "1:487503667844:web:b0be60cdd759ed1b2198d1",
};

// Use this to initialize the firebase App
const firebaseApp = firebase.initializeApp(firebaseConfig);

// Use these for db & auth
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();
const signInWithGoogle = () => auth.signInWithPopup(provider);
export {auth, db, signInWithGoogle, firebaseConfig};
